
import { defineComponent } from 'vue'
import AboutMe from '@/components/ja/top/AboutMe.vue'
import UpdateNews from '@/components/ja/top/UpdateNews.vue'
import ContactInfo from '@/components/ja/top/ContactInfo.vue'

export default defineComponent({
  name: 'TopJa',
  components: {
    AboutMe,
    UpdateNews,
    ContactInfo
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'top'
    }
  }
})
